/* global google */

import React from 'react';
import Promise from 'bluebird';
import { parseAddress } from 'shared/models/address';

function withGeocoder(WrappedComponent) {
  class Wrapper extends React.Component {
    constructor(props) {
      super(props);
      this.geocode = this.geocode.bind(this);
    }

    componentDidMount() {
      this.geocoder = new google.maps.Geocoder();
    }

    geocode(address) {
      return new Promise((resolve, reject) => {
        this.geocoder.geocode({ address }, (results, status) => {
          if (status === 'OK') {
            const parsed = parseAddress(results[0]);
            resolve(parsed);
          } else {
            reject(new Error(`Geocode failed: ${status}`));
          }
        });
      });
    }

    render() {
      return <WrappedComponent geocode={this.geocode} {...this.props} />;
    }
  }

  Wrapper.displayName = `WithGeocoder(${getDisplayName(WrappedComponent)})`;

  return Wrapper;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default withGeocoder;



// WEBPACK FOOTER //
// ./shared/components/address/geocoder.js